import { render, staticRenderFns } from "./ForgotPasswordChangePassword.vue?vue&type=template&id=6c7efb2e&scoped=true"
import script from "./ForgotPasswordChangePassword.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordChangePassword.vue?vue&type=style&index=0&id=6c7efb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7efb2e",
  null
  
)

export default component.exports